import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { UserProfile } from 'src/types/auth.types'

export type AuthSliceType = {
    user: UserProfile
}

const initialState: AuthSliceType = {
    user: {
        first_name: '',
        is_activated: false,
        last_name: '',
        login_via: '',
        state: 0,
        status: '',
        token: '',
        user_id: '',
        organizations: [],
        roles: [],
        email: '',
    },
}

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setUserAction: (state: AuthSliceType, action: PayloadAction<UserProfile>) => {
            state.user = action.payload
        },
    },
})

export const { setUserAction } = authSlice.actions
